import { ItemList } from 'common/ITEMS/Item';

const items: ItemList = {
  //region Devastation
  //endregion
  //region Preservation
  T30_SPIRITBLOOM_HOT: {
    id: 409895,
    name: 'Spiritbloom',
    icon: 'ability_evoker_spiritbloom2',
  },
  T30_ESSENCE_RUSH: {
    id: 409899,
    name: 'Essence Rush',
    icon: 'ability_evoker_essenceburststacks',
  },
  KHARNALEX_THE_FIRST_LIGHT: {
    id: 195519,
    name: 'Kharnalex, The First Light',
    icon: 'inv_staff_2h_dragondungeon_c_02',
  },
  //endregion
  //region Shared
  //endregion
};
export default items;
